/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ElementsUserMiniReference,
    ElementsUserMiniReferenceFromJSON,
    ElementsUserMiniReferenceFromJSONTyped,
    ElementsUserMiniReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface AssetRatingPartialUpdate
 */
export interface AssetRatingPartialUpdate {
    /**
     * 
     * @type {ElementsUserMiniReference}
     * @memberof AssetRatingPartialUpdate
     */
    user?: ElementsUserMiniReference;
    /**
     * 
     * @type {number}
     * @memberof AssetRatingPartialUpdate
     */
    rating?: number;
    /**
     * 
     * @type {number}
     * @memberof AssetRatingPartialUpdate
     */
    asset?: number;
}

export function AssetRatingPartialUpdateFromJSON(json: any): AssetRatingPartialUpdate {
    return AssetRatingPartialUpdateFromJSONTyped(json, false);
}

export function AssetRatingPartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetRatingPartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user': !exists(json, 'user') ? undefined : ElementsUserMiniReferenceFromJSON(json['user']),
        'rating': !exists(json, 'rating') ? undefined : json['rating'],
        'asset': !exists(json, 'asset') ? undefined : json['asset'],
    };
}

export function AssetRatingPartialUpdateToJSON(value?: AssetRatingPartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user': ElementsUserMiniReferenceToJSON(value.user),
        'rating': value.rating,
        'asset': value.asset,
    };
}


